import { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

interface UsePublicationLogicProps {
  publication: any;
  brandsDealerships?: any[];
  selectedDealership?: any;
  setSelectedDealership?: any;
  selectedVersion?: string;
  setSelectedVersion?: any;
  setVehicleTypeReducer?: any;
}

export const usePublicationLogic = ({
  publication,
  brandsDealerships,
  selectedDealership,
  setSelectedDealership,
  selectedVersion,
  setSelectedVersion,
  setVehicleTypeReducer
}: UsePublicationLogicProps) => {
  const location = useLocation();
  const [openAdditionalModal, setOpenAdditionalModal] = useState(false);

  // Calcular precio mínimo
  const getMinPrice = useMemo(() => {
    let minPrice = publication?.price || 0;

    if (publication?.versions && publication.versions.length > 0) {
      publication.versions.forEach((version: any) => {
        if (version.price && (version.price < minPrice || minPrice === 0)) {
          minPrice = version.price;
        }
      });
    }

    return minPrice;
  }, [publication]);

  // Obtener datos del vehículo seleccionado para marcas
  const selectedVehicleData = useMemo(() => {
    if (!publication?.versions || !selectedVersion) {
      return {
        year: publication?.year,
        mileage: publication?.mileage
      };
    }

    const selectedVehicle = publication.versions.find((v: any) => v.id === selectedVersion);
    return {
      year: selectedVehicle?.year || publication?.year,
      mileage: selectedVehicle?.mileage || publication?.mileage
    };
  }, [publication, selectedVersion]);

  // Efecto para seleccionar la versión inicial
  useEffect(() => {
    if (publication?.versions && publication.versions.length > 0 && !selectedVersion) {
      const sortedVersions = [...publication.versions].sort((a, b) => (a.price || 0) - (b.price || 0));
      setSelectedVersion?.(sortedVersions[0].id);
    }
  }, [publication, selectedVersion, setSelectedVersion]);

  // Efecto para seleccionar el concesionario inicial
  useEffect(() => {
    if (brandsDealerships && brandsDealerships.length > 0) {
      const dealerIds = brandsDealerships.map((dealer: any) => dealer.id || dealer._id);
      if (!selectedDealership || !dealerIds.includes(selectedDealership)) {
        const firstDealerId = brandsDealerships[0].id || brandsDealerships[0]._id;
        console.log('Seleccionando concesionario inicial:', firstDealerId, brandsDealerships[0]);
        setSelectedDealership?.(firstDealerId);
      }
    }
  }, [brandsDealerships, selectedDealership, setSelectedDealership]);

  // Efecto para establecer el tipo de vehículo basado en la URL
  useEffect(() => {
    if (location.pathname.includes('nuevos') || location.pathname.includes('usados')) {
      const vehicleType = location.pathname.includes('nuevos') ? 'new' : 'used';
      setVehicleTypeReducer?.(vehicleType);
    }
  }, [location.pathname, setVehicleTypeReducer]);

  return {
    getMinPrice,
    selectedVehicleData,
    openAdditionalModal,
    setOpenAdditionalModal
  };
};
